import script from "./DSecretInput.vue?vue&type=script&setup=true&lang=js"
export * from "./DSecretInput.vue?vue&type=script&setup=true&lang=js"

import "./DSecretInput.vue?vue&type=style&index=0&id=0f85ed5d&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f85ed5d"]])

export default __exports__